/** client/src/LandingPage.js **/ 

import React from 'react';

const LandingPage = () => (
  <div style={{ padding: 40 }}>
    <h1>Welcome to My App</h1>
    <p>Please log in or register to continue.</p>
  </div>
);

export default LandingPage;